import React from "react";
import type { EmindFullPageLoaderProps } from "../types/EmindFullPageLoader";
import "../styles/emind-loader.scss";

const BRAND: string[] = ["e", "\u2011", "m", "i", "n", "d"];

/**
 * Полноэкранный индикатор с анимацией слова «e‑mind» (медленная сеть / ожидание данных).
 */
export default function EmindFullPageLoader({
    label = "Загрузка",
    caption,
}: EmindFullPageLoaderProps) {
    return (
        <div className="emind-loader-root" role="status" aria-live="polite" aria-label={label}>
            <div className="emind-loader-brand" aria-hidden>
                {BRAND.map((ch, i) => (
                    <span
                        key={i}
                        className="emind-loader-char"
                        style={{ animationDelay: `${i * 0.09}s` }}
                    >
                        {ch}
                    </span>
                ))}
            </div>
            <div className="emind-loader-line" aria-hidden />
            {caption ? <p className="emind-loader-caption">{caption}</p> : null}
        </div>
    );
}
